import React from "react";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../images/defaultImage.png";

const FacebookBCAccess = ({ data, count, adAccounts }: any) => {
  const history = useNavigate();
  const onConnect = (item: any) => {
    localStorage.setItem("fbbPageDetail", JSON.stringify(item));

    history("/adaccountspage");
  };

  return (
    <>
      <div className="text-center">
        <h3 className="fbtext">
          {data && count ? (
            <div>
              We found {count ? count : 0} Facebook Pages managed by you.
            </div>
          ) : (
            <div>Fetching Facebook Pages</div>
          )}
        </h3>
      </div>
      <div
        className="custom-scrollbar-css p-2"
        style={{ maxHeight: "65vh", overflowY: "auto" }}>
        {data && count > 0
          ? data.map((item: any, index: any) => {
              return (
                <div className="card" key={index}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="widgets_div d-flex align-items-center">
                        <div className="icon_div">
                          <span>
                            {item?.facebook?.pagePictureUrl ? (
                              <img
                                src={item?.facebook?.pagePictureUrl}
                                className="rounded-circle avatar-sm"
                                alt=""
                              />
                            ) : (
                              <img
                                src={defaultImage}
                                alt=""
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                          </span>
                        </div>
                        <div className="av-div">{item?.facebook?.pageName}</div>
                      </div>
                      <div className="text-right">
                        <button
                          type="button"
                          className="btn rounded-pill btn-small btn-sm btn-primary"
                          style={{ float: "right" }}
                          onClick={() => onConnect(item)}>
                          Access
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </>
  );
};

export default FacebookBCAccess;
